import { PlatformLocation } from '@angular/common';
import { inject, InjectionToken, Injector, provideAppInitializer, runInInjectionContext } from '@angular/core';
import type { IconResolver } from '@angular/material/icon';
import { MatIconRegistry } from '@angular/material/icon';

export type IconResolverFn = () => IconResolver;
export const ICON_RESOLVER = new InjectionToken<IconResolverFn>('ICON_RESOLVER');
export const ICON_RESOLVER_BASE_HREF = new InjectionToken<string>('ICON_RESOLVER_BASE_HREF', {
  factory: () => {
    const platformLocation = inject(PlatformLocation);
    return platformLocation.getBaseHrefFromDOM();
  },
});

export const provideIcons = (iconResolver: IconResolverFn) => [
  MatIconRegistry,
  { provide: ICON_RESOLVER, useValue: iconResolver },
  provideAppInitializer(() => {
    const matIconRegistry = inject(MatIconRegistry);
    const resolver = inject(ICON_RESOLVER);
    const injector = inject(Injector);
    matIconRegistry.addSvgIconResolver(runInInjectionContext(injector, resolver));
  }),
];
